import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './DeliveryFrequency.module.sass';
import learnMoreIcon from '../../../../../../images/icons/learn-more.svg';
import closeIcon from '../../../../../../images/icons/close.svg';
import Select from '../../../../../ui_kit/select/Select';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';
import Toggle from '../../../../../ui_kit/toggle/Toggle';
import DELIVERY_INTERVALS from '../../../../constants/delivery_intervals';

function DeliveryFrequency(props) {
  const {
    selectedDeliveryFrequency, setSelectedDeliveryFrequency, subscriptionDiscountPercentage,
  } = props;

  const defaultDeliveryFrequency = Number(Object.keys(DELIVERY_INTERVALS.ONLY_MONTHS)[2]);

  const [deliveryFrequency, setDeliveryFrequency] = useState(
    defaultDeliveryFrequency,
  );

  const [showHint, setShowHint] = useState(false);

  const toggle = () => {
    if (selectedDeliveryFrequency === 0) {
      setSelectedDeliveryFrequency(deliveryFrequency);
    } else {
      setSelectedDeliveryFrequency(0);
    }
  };

  return (
    <div className={styles.frequency}>
      <div className={styles.col}>
        <Toggle
          onChange={toggle}
          checked={selectedDeliveryFrequency === 0}
          label="Buy Once"
          className={styles.toggle}
        />
        <Toggle
          onChange={toggle}
          checked={selectedDeliveryFrequency !== 0}
          label="Ships every"
          className={styles.toggle}
        />
      </div>
      <div className={styles.col}>
        <ClickableDiv className={styles.hint} onClick={() => { setShowHint(!showHint); }}>
          <img src={learnMoreIcon} alt="Learn More" />
        </ClickableDiv>
        <Select
          value={deliveryFrequency}
          options={Object.keys(DELIVERY_INTERVALS.ONLY_MONTHS).map(
            (key) => ({
              value: key,
              label: (
                Number(key) === defaultDeliveryFrequency
                && deliveryFrequency !== defaultDeliveryFrequency
              ) ? `${DELIVERY_INTERVALS.ONLY_MONTHS[key].toUpperCase()} (RECOMMENDED)` : DELIVERY_INTERVALS.ONLY_MONTHS[key].toUpperCase(),
            }),
          )}
          onChange={(event) => {
            setDeliveryFrequency(Number(event.target.value));
            setSelectedDeliveryFrequency(Number(event.target.value));
          }}
          className={styles.select}
        />
        <small>
          {subscriptionDiscountPercentage > 0 ? `${subscriptionDiscountPercentage}% off` : ''}
          {' '}
          + Free Replenishment Shipping
        </small>
      </div>
      { showHint && (
        <div className={styles['hint-block']}>
          <div className={styles.row}>
            <div className={styles.title}>
              HOW SUBSCRIPTION WORKS
            </div>
            <ClickableDiv
              className={styles.close}
              onClick={() => {
                setShowHint(false);
              }}
            >
              <img src={closeIcon} alt="close" />
            </ClickableDiv>
          </div>
          <ul>
            <li>Pick how frequently you want your Volition product(s) at your doorstep</li>
            <li>
              {`Get${subscriptionDiscountPercentage > 0 ? ` ${subscriptionDiscountPercentage}% off +` : ''} free-shipping on any auto-replenishment order`}
            </li>
            <li>Edit your frequency or quantity at any time</li>
            <li>End your subscription whenever (no penalties!)</li>
          </ul>
          <a href="/pages/faqs/" target="_blank">
            READ MORE IN OUR FAQ
          </a>
        </div>
      )}
    </div>
  );
}

DeliveryFrequency.propTypes = {
  selectedDeliveryFrequency: PropTypes.number.isRequired,
  setSelectedDeliveryFrequency: PropTypes.func.isRequired,
  subscriptionDiscountPercentage: PropTypes.number.isRequired,
};

export default DeliveryFrequency;
